<template>
	<div>
		<div class="container-fluid">
			<form id="form" class="form-horizontal" action="." method="post">
				<div class="tabs text-center">
					<button
						@click.prevent="tab = 'main'"
						:class="tab === 'main' ? 'active' : ''"
						class="btn"
					>
						{{ 'General' | translate }}
					</button>
					<button
						@click.prevent="tab = 'secondary'"
						:class="tab === 'secondary' ? 'active' : ''"
						class="btn"
					>
						{{ 'Additional' | translate }}
					</button>
					<button
						@click.prevent="tab = 'documents'"
						:class="tab === 'documents' ? 'active' : ''"
						class="btn"
					>
						{{ 'Documents' | translate }}
					</button>
					<button
						v-if="myRole === 'super franchise'"
						@click.prevent="tab = 'comment'"
						:class="tab === 'comment' ? 'active' : ''"
						class="btn"
					>
						{{ 'Comment' | translate }}
					</button>
				</div>
				<div class="row">
					<div
						v-show="tab === 'main'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset>
							<legend>{{ 'General information' | translate }}</legend>
							<div class="form-group">
								<label>Email</label>
								<div>
									<input
										v-model="teacher.email"
										:class="emailError ? 'error' : ''"
										type="email"
										class="form-control"
									/>
								</div>
								<div class="text-right text-danger" v-if="emailError">
									{{ emailError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Phone number' | translate }}</label>
								<div>
									<input
										:class="numberError ? 'error' : ''"
										v-model="teacher.phone_number"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="text-right text-danger" v-if="numberError">
									{{ numberError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Date of birth' | translate }}</label>
								<div class="date-group">
									<datepicker
										v-model="teacher.birthday"
										:format="format"
									></datepicker>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'First name' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="teacher.first_name"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Surname' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="teacher.middle_name"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Last name' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="teacher.last_name"
										class="form-control"
									/>
								</div>
							</div>
							<div
								class="form-group"
								v-if="
									myRole === 'super franchise' || myRole === 'master franchise'
								"
							>
								<label>{{ 'Franchise' | translate }}</label>
								<div>
									<v-select
										:value.sync="choosedFranchise"
										:on-change="changeFranchise"
										:options="franchiseList"
									></v-select>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-show="tab === 'documents'"
						class="tab-content col-lg-6 mr-auto ml-auto  col-md-8 col-sm-12"
					>
						<fieldset class="scans">
							<legend>{{ 'Documents' | translate }}</legend>
							<div class="form-group">
								<input
									type="file"
									ref="file"
									@change="uploadImage"
									class="btn btn-secondary form-control-file"
								/>
							</div>
							<div v-for="(file, i) in fileList" :key="i" class="item row">
								<div class="col-sm-12 col-md-6">{{ file.name }}</div>
								<div class="actions col-md-6 col-sm-12">
									<a
										:href="'https://api.indigo.teeko.io' + file.file"
										download
										class="btn btn-success"
										>{{ 'Download' | translate }}</a
									>
									<button
										@click.prevent="deleteFile(file.id)"
										class="btn btn-danger"
									>
										{{ 'Delete' | translate }}
									</button>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-show="tab === 'secondary'"
						class="tab-content col-lg-6 mr-auto ml-auto col-md-8 col-sm-12"
					>
						<fieldset>
							<legend>{{ 'Additional information' | translate }}</legend>
							<div class="form-group">
								<label>{{ 'Region' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="teacher.region"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Passport' | translate }}</label>
								<div>
									<textarea
										v-model="teacher.passport"
										class="form-control"
									></textarea>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Id code' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="teacher.tax_id"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group checkbox">
								<label>
									<input
										type="checkbox"
										:disabled="myRole !== 'super franchise'"
										v-model="teacher.is_email_subscribed"
									/>{{ 'With email newsletter' | translate }}
								</label>
							</div>
						</fieldset>
					</div>
					<div
						v-if="myRole === 'super franchise'"
						v-show="tab === 'comment'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto  col-sm-12"
					>
						<b>{{ 'Comment' | translate }}</b>
						<textarea
							class="form-control"
							v-model="teacher.comments"
						></textarea>
					</div>
				</div>
				<div class="col-12 text-center">
					<input
						type="submit"
						:value="'Save' | translate"
						@click.prevent="changeProfile"
						class="btn btn-primary submit"
					/>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
export default {
	name: 'Teacher',
	data() {
		return {
			tab: 'main',
			fileList: [],
			format: 'dd/MM/yyyy',
			royalty: '',
			prDeposit: '',
			currency: '',
			comments: '',
			franchiseList: [],
			choosedFranchise: '',
			numberError: '',
			emailError: '',
			myRole: '',
			idForImage: '',
		}
	},
	components: {
		Datepicker,
		vSelect,
	},
	computed: {
		teacher() {
			return this.$store.state.profile
		},
	},
	methods: {
		deleteFile(fileId) {
			this.axios({
				method: 'delete',
				url: `billing/files/${fileId}`,
			}).then(response => {
				this.reloadDocuments()
			})
		},
		uploadImage(e) {
			let files = e.target.files
			let data = new FormData()
			for (var i = 0; i < files.length; i++) {
				let file = files.item(i)
				data.append(file.name, file, file.name)
			}
			const config = {
				headers: {
					'content-type': 'multipart/form-data',
				},
			}
			return this.axios
				.post(`billing/files?uploaded_by=${this.idForImage}`, data, config)
				.then(response => {
					this.reloadDocuments()
				})
		},
		reloadDocuments() {
			this.axios({
				method: 'get',
				url: `billing/files?user=${this.idForImage}`,
			}).then(response => {
				this.fileList = response.data
			})
		},
		changeProfile() {
			let error = false
			this.emailError = ''
			this.numberError = ''
			this.detailError = ''

			if (this.teacher.email === '') {
				this.emailError = this.$t('Field required')
				error = true
			}

			if (this.teacher.phone_number === '') {
				this.numberError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let birthday = null
			let method = 'post'
			if (this.$route.params.id !== 'me') {
				method = 'patch'
			}

			if (
				this.teacher.birthday !== null &&
				this.teacher.birthday !== '' &&
				this.teacher.birthday.length !== 10
			) {
				birthday = this.teacher.birthday.toISOString().slice(0, 10)
			}

			this.axios({
				method: method,
				url: `users/user/${this.$route.params.id}`,
				data: {
					email: this.teacher.email,
					phone_number: this.teacher.phone_number,
					first_name: this.teacher.first_name,
					middle_name: this.teacher.middle_name,
					last_name: this.teacher.last_name,
					passport: this.teacher.passport,
					region: this.teacher.region,
					tax_id: this.teacher.tax_id,
					is_email_subscribed: this.teacher.is_email_subscribed,
					comments: this.teacher.comments,
					birthday: birthday,
					parent: this.teacher.parent,
				},
			})
				.then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
				})
				.catch(error => {
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.emailError = this.$t(error.response.data.detail[0])
					}
				})
		},
		changeFranchise(val) {
			if (val !== null) {
				this.parent = val.value
			}
		},
		updateUserInfo() {
			let profile = this.$store.state.profile
			this.axios({
				method: 'get',
				url: 'users/user/me',
			}).then(response => {
				if (this.$route.params.id === 'me') {
					this.myRole = profile.role
					this.idForImage = response.data.id
				} else {
					this.myRole = response.data.role
					this.idForImage = this.$route.params.id
				}
				this.reloadDocuments()
			})

			if (this.myRole !== 'teacher' && this.myRole !== 'franchise') {
				this.axios({
					method: 'get',
					url: 'users?role=franchise',
				}).then(response => {
					let franchiseArray = response.data
					for (var i = 0; i < franchiseArray.length; i++) {
						let franchise = {
							value: franchiseArray[i].id,
							label:
								franchiseArray[i].last_name +
								' ' +
								franchiseArray[i].first_name +
								' ' +
								franchiseArray[i].middle_name,
						}
						this.franchiseList.push(franchise)
					}
				})

				this.axios({
					method: 'get',
					url: `users/user/${profile.parent}`,
				}).then(response => {
					this.choosedFranchise =
						response.data.last_name +
						' ' +
						response.data.first_name +
						' ' +
						response.data.middle_name
				})
			}
		},
	},
	created() {
		this.updateUserInfo()
	},
	watch: {
		$route(from, to) {
			this.updateUserInfo()
		},
	},
}
</script>

<style scoped>
.nav-pills li {
	margin: 10px;
}

.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.nav-pills {
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

nav {
	margin: 50px auto;
}

.tabs .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

.tabs .active {
	background-color: #fff;
}

.tab-content {
	border: 1px solid buttonface;
	border-radius: 10px;
	background: #fff;
	padding-top: 30px;
	padding-bottom: 30px;
}

span {
	margin-bottom: 20px;
	display: block;
}
</style>
